import { render } from "./DataAdministrationView.vue?vue&type=template&id=637293e9"
import script from "./DataAdministrationView.vue?vue&type=script&lang=js"
export * from "./DataAdministrationView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__